import { render, staticRenderFns } from "./UniqueSellingPoints.vue?vue&type=template&id=3d4764bc&"
import script from "./UniqueSellingPoints.js?vue&type=script&lang=js&"
export * from "./UniqueSellingPoints.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports